import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { identity, pipe } from 'fp-ts/function';
import * as S from 'fp-ts/Semigroup';

export const firstRight = <C, T>(
  candidate: C,
  defaultT: T,
  resolvers: [(candidate: C) => boolean, (candidate: C) => T][]
): T => {
  const firstRightSemi = E.getSemigroup<T, T>(S.first<T>());
  const concatFirstRightSemi = S.concatAll(firstRightSemi)(E.left(defaultT));
  return pipe(
    concatFirstRightSemi(
      pipe(
        resolvers,
        A.map(r =>
          pipe(
            candidate,
            E.fromPredicate(r[0], () => defaultT),
            E.map(r[1])
          )
        )
      )
    ),
    E.fold(identity, identity)
  );
};
